import { FCX } from "@datassential/platform-ui-lib";
import './BarChart.scss';
import cn from "classnames";

const FoodBarChart: FCX<{
    valuePct: number;
    hasInlay?: boolean;
    colorStart?: string;
    colorStop?: string;
}> = ({
    valuePct,
    hasInlay = false,
    colorStart = '#2D3A4C',
    colorStop = '#2D3A4C',
    className,
    style,
    testId,
}) => {
    return (
        <div
            className={cn(className, "FoodBarChart", hasInlay && 'is-bg')}
            style={style}
            data-testid={testId}
        >
            <div
                className="FoodBarChart__bar"
                style={{
                    backgroundImage: `linear-gradient(to right, ${colorStart}, ${colorStop})`,
                    width: `${valuePct}%`,
                }}
            />
        </div>
    );
};

export default FoodBarChart;